import script from "./CResultTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CResultTable.vue?vue&type=script&setup=true&lang=ts"

import "./CResultTable.vue?vue&type=style&index=0&id=4ca9754f&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca9754f"]])

export default __exports__